import React from 'react'
import { Text } from './style'
import { FormattedMessage } from 'react-intl'
import { ButtonBorder, ButtonFull } from 'components/Form/Button'
import { useDispatch } from 'react-redux'
import { closeOpenedOrders } from 'containers/Orders/slices'
import { cleanItems } from 'components/Steps/slices'

const CheckOrderIdPopup = ({ orderId, onClose = () => {} }) => {
	const dispatch = useDispatch()
	return (
		<>
			<Text className='text-center'>
				<FormattedMessage
					id='orders.choose.other.warning.text'
					defaultMessage='All your selections will be discarded.'
				/>
			</Text>
			<ButtonFull
				w100
				dark
				className='mb-3 yesButton'
				onClick={() => {
					dispatch(closeOpenedOrders(orderId))
					dispatch(cleanItems())
					onClose()
				}}
			>
				<FormattedMessage
					id='orders.choose.other.warning.confirm.button'
					defaultMessage='YES, CLEAR MY PREVIOUS PRODUCT SELECTION'
				/>
			</ButtonFull>
			<ButtonBorder w100 onClick={onClose} className='noButton'>
				<FormattedMessage
					id='orders.choose.other.warning.cancel.button'
					defaultMessage='NO'
				/>
			</ButtonBorder>
		</>
	)
}
export default CheckOrderIdPopup
